import { notification } from "antd";

export const dateFormatter = new Intl.DateTimeFormat("hu-HU");
export const addressFormatter = {
  format: (v) => v?.replace?.("Magyarország", ""),
};
export const statusFormatter = {
  values: {
    Ordered: "Megrendelve",
      Pending: "Folyamatban",
      Paid: "Fizetve",
  },
  format: (v) =>
    ({
      Ordered: "Megrendelve",
      Pending: "Folyamatban",
      Paid: "Fizetve",
    }[v] || "-"),
};

export const paymentFormatter = {
  values: {
     "BankTransfer": "Utalás",
      "OnlineCard": "Kártyával online",
      "Card": "Kártyával",
      "Cash": "KP",
      "Prepaid": "Pontos",
  },
  format: (v) =>
    ({
      "BankTransfer": "Utalás",
      "OnlineCard": "Kártyával online",
      "Card": "Kártyával",
      "Cash": "KP",
      "Prepaid": "Pontos",
    }[v] || "-"),
};

export const moneyFormatter = new Intl.NumberFormat("hu-HU", {
  currency: "HUF",
  style: "currency",
  maximumFractionDigits: 0
});

export const weekDayFormatter = new Intl.NumberFormat("hu-HU", {
  currency: "HUF",
  style: "currency",
});

export const notify = (promise) => {
  return promise
    .then((x) => {
      notification.success({
        message: "Sikeres muvelet",
      });
    })
    .catch((err) => {
      notification.error({ message: err.toString() });
    });
};

export const wait = t => new Promise((resolve) => setTimeout(() => resolve(),t));

//const sortByIndex = (array, oldIndex, newIndex) => {
//  // first we find the real index
//}

export const sortByIndex = (array, key = 'index') => (value, record) => {
  const shift = +Boolean(array.find(x => x[key] === +value));
  const original = array.findIndex(x => x === record);
  let newData = array.map((x, _index) => {
      if (_index === original) {
        return {
            ...x,
            [key]: +value,
            oldIndex: x.index,
        }
      }
      if (x[key] >= value) {
          return {
              ...x,
              [key]: x[key] + shift,
              oldIndex: x.index,
          }
      }
      return x;
  }).sort((a,b) => a[key] - b[key]);
  return newData;
}

export const sortByMetaIndex = (a,b) => {
  return +(a?.meta?.find?.(x => x?.key === "index")?.value || 0) - +(b?.meta?.find?.(x => x?.key === "index")?.value || 0)
}